<script setup>
import Button from "@/Components/Button.vue";

defineProps({
    type: {
        type: String,
        default: "button",
    },
});
</script>

<template>
    <Button
        :type="type"
        color="secondary"
    >
        <slot />
    </Button>
</template>
